module.exports = __webpack_public_path__ + "assets/metrics-dollar.b24723db.svg";